module.exports = __webpack_public_path__ + "static/media/Cit-Formation.482aa14c.png";